import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { WorkflowCreateBody, WorkflowHttpControl } from "@workerstation/shared/resources/workflow";
import type { WorkflowDefinitionTarget, WorkflowInstanceTarget, WorkflowInstance, WorkflowSnapshot } from "./model.ts";
export interface WorkflowApiShape {
  readonly load: (workspaceId: string) => Effect.Effect<WorkflowSnapshot, ResourceFailure>;
  readonly start: (target: WorkflowDefinitionTarget, options: typeof WorkflowCreateBody.Type) => Effect.Effect<WorkflowInstance, ResourceFailure>;
  readonly control: (target: WorkflowInstanceTarget, action: WorkflowHttpControl) => Effect.Effect<WorkflowInstance, ResourceFailure>;
}
export class WorkflowApi extends Context.Service<WorkflowApi, WorkflowApiShape>()("workerstation/frontend/WorkflowApi") {}
